import React from "react";
import Seo from "../components/Seo";
import Documentation from "../documentation/Documentation";
import {documentationPage} from "../documentation/pages";

export default function SiteDocumentation({page}) {
    const details = documentationPage(page);
    return <>
        <Seo title={page === "index" ? details.title : `XMQ MQTT Server – ${details.title}`}
             description={details.description} path={details.path}/>
        <Documentation page={page}/>
    </>;
}
